import * as React from 'react'
import { getRelativeTimeMessage } from '../../../shared/lib/relativeTimeMessage.no-deps'
import { GuideTile } from '../../../shared/webcomponents/react-wrappers/GuideTile'
import type { CommonDeps } from '../base/CommonDeps'
import type { RenderCachedImage } from '../image/WithCachedImage'
import { GuideParentInfo } from './GuideParentInfo'
import type { AppGuide, ParentInfo } from './Model'

interface Props {
    deps: CommonDeps
    guide: AppGuide
    iconUrl: string
    onClick: () => void
    onClickGuideParentInfo?: (parentInfo: ParentInfo) => void
    renderCachedImage: RenderCachedImage
}

export function GuideListItem(props: React.PropsWithChildren<Props>) {
    const { deps, guide, iconUrl, onClick, onClickGuideParentInfo, renderCachedImage } = props
    const { locale } = deps

    return (
        <div className="AppCore__guide__GuideListItem-guide-tile">
            <GuideTile
                id={guide.id}
                icon={iconUrl}
                title={guide.name}
                subtitle={getRelativeTimeMessage(locale, guide.serverSyncTime, new Date())}
                isVideo={guide.variant === 'file' && guide.isVideoFileGuide}
                onClick={(_) => onClick()}
            >
                {props.children}
                {guide.parentInfo && (
                    <GuideParentInfo
                        deps={deps}
                        parentInfo={guide.parentInfo}
                        renderCachedImage={renderCachedImage}
                        onClickGuideParentInfo={onClickGuideParentInfo}
                    />
                )}
            </GuideTile>
        </div>
    )
}
